export enum DateIntervalType {
    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    BIWEEKLY    = 'biweekly',
    MONTHLY     = 'monthly',
    QUARTERLY   = 'quarterly',
    YEARLY      = 'yearly',
}

export const DATE_INTERVAL_OPTIONS: Options = [
    {
        value: DateIntervalType.DAILY,
        label: 'Day'
    },
    {
        value: DateIntervalType.WEEKLY,
        label: 'Week'
    },
    {
        value: DateIntervalType.BIWEEKLY,
        label: 'Bi-weekly'
    },
    {
        value: DateIntervalType.MONTHLY,
        label: 'Month'
    },
    {
        value: DateIntervalType.QUARTERLY,
        label: 'Quater'
    },
    {
        value: DateIntervalType.YEARLY,
        label: 'Year'
    },
]



export enum TickType {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
}

export const TickTypeLabel = {
    [TickType.DAY]: 'Day',
    [TickType.WEEK]: 'Week',
    [TickType.MONTH]: 'Month',
}
export const tickTypeOptions: Option[] = [
    {value: TickType.DAY, label: TickTypeLabel[TickType.DAY]},
    {value: TickType.WEEK, label: TickTypeLabel[TickType.WEEK]},
    {value: TickType.MONTH, label: TickTypeLabel[TickType.MONTH]},
]